// react
import { createContext, useContext } from 'react';

export interface BreadcrumbContextValue {
  /** Dynamic label overrides keyed by route match id. */
  overrides: Record<string, string>;
  setOverride: (matchId: string, label: string) => void;
  clearOverride: (matchId: string) => void;
}

export const BreadcrumbContext = createContext<
  BreadcrumbContextValue | undefined
>(undefined);

export function useBreadcrumbContext() {
  const context = useContext(BreadcrumbContext);

  if (!context) {
    throw new Error(
      'useBreadcrumbContext must be used within a BreadcrumbProvider',
    );
  }

  return context;
}
